import React, { useState, useEffect } from "react";
import { Card, Nav, Row, Col, Button, Spinner, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TipsNews.css";
import { useNavigate } from "react-router-dom";

import TipsSection from "./TipsSection";
import JobSeekerNavbar from "../../Pages/Navbar/AgencyNavbar";
import Footer from "../../Footer/Footer";
import BaseUrl from "../../ApiServices/BaseUrl";

const NewsTipsSection = () => {
  const [activeKey, setActiveKey] = useState("news");
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  // Fetch news data from backend
  const fetchNewsData = async () => {
    try {
      setLoading(true);
      console.log("Fetching news data...");

      const response = await fetch(`${BaseUrl}/api/news/all`);
      console.log("Raw response:", response);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Fetched news data:", data);

      // Show all articles (remove the published filter for testing)
      setNewsData(data);

      // Extract unique categories
      const uniqueCategories = [...new Set(data.map(item => item.category))];
      setCategories(["All", ...uniqueCategories]);

    } catch (err) {
      setError(err.message);
      console.error("Error fetching news data:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (activeKey === "news") {
      fetchNewsData();
    }
  }, [activeKey]);

  // Format date function
  const formatDate = dateString => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Date(dateString).toLocaleDateString("en-US", options);
  };

  // Handle Read More click
  const handleReadMore = (articleId) => {
    navigate(`/articledetailsagency/${articleId}`);
  };

  if (loading && activeKey === "news") {
    return (
      <>
        <JobSeekerNavbar />
        <div className="container mt-4" style={{ paddingTop: "80px" }}>
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error && activeKey === "news") {
    return (
      <>
        <JobSeekerNavbar />
        <div className="container mt-4" style={{ paddingTop: "80px" }}>
          <Alert variant="danger">Error loading news: {error}</Alert>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <JobSeekerNavbar />
      <div className="container mt-4" style={{ paddingTop: "80px" }}>
        {/* Tabs */}
        <Nav activeKey={activeKey} onSelect={k => setActiveKey(k)} className="custom-tabs mb-3">
          <Nav.Item>
            <Nav.Link eventKey="news">
              <i className="bi bi-newspaper"></i> News
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="tips">
              <i className="bi bi-lightbulb"></i> Tips
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* News Section */}
        {activeKey === "news" && (
          <>
            <Card className="p-4 shadow-sm mb-4">
              <Card.Body>
                <h4 className="fw-bold text-primary">Popular Post and Last News</h4>
                <div className="yellow-underline"></div>
                <p className="text-muted">
                  We keep you updated about the Domestic Helpers Community and list here all our popular and useful articles
                  (regulation, management, worker's rights, trainings...).
                </p>
              </Card.Body>
            </Card>

            <Row>
              {/* Left side - News Cards */}
              <Col md={12}>
                <Row>
                  {newsData.length > 0 ? (
                    newsData.map(newsItem => (
                      <Col md={4} sm={12} className="mb-4" key={newsItem.id}>
                        <Card className="h-100 shadow-sm">
                          <Card.Img
                            variant="top"
                            src={newsItem.image_url || "/placeholder-image.jpg"}
                            className="fixed-img"
                            alt={newsItem.title}
                            onError={e => (e.target.src = "/placeholder-image.jpg")}
                          />
                          <Card.Body className="d-flex flex-column">
                            <div className="d-flex justify-content-between text-muted small mb-2">
                              <span>
                                <i className="bi bi-calendar-event"></i> {formatDate(newsItem.publish_date)}
                              </span>
                              <span>
                                <i className="bi bi-clock"></i> {newsItem.read_time || "5 min read"}
                              </span>
                            </div>
                            <Card.Title className="fw-bold text-primary">{newsItem.title}</Card.Title>
                            <Card.Text className="text-muted flex-grow-1">{newsItem.excerpt}</Card.Text>
                            <Button 
                              variant="" 
                              onClick={() => handleReadMore(newsItem.id)}
                              style={{backgroundColor:'#0d6efd', color:'white'}}
                            >
                              READ MORE
                            </Button>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))
                  ) : (
                    <Col md={12}>
                      <Alert variant="info">No news articles found.</Alert>
                    </Col>
                  )}
                </Row>
              </Col>
            </Row>
          </>
        )}

        {/* Tips Section */}
        {activeKey === "tips" && <TipsSection />}
      </div>
      <Footer />
    </>
  );
};

export default NewsTipsSection;